<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3">
                <div v-if="tipo_svg === 1">
                    <SvgPanZoom 
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="false"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                    >
                        <svg v-html="svg_loaded"></svg>
                    </SvgPanZoom>
                    <div class="text-center" v-if="load_panzoom">
                        <button @click="zoomIn()" class="button panzoom-button">+</button>
                        <button @click="zoomOut()" class="button panzoom-button">-</button>
                    </div>
        
                    <template v-if="!loading">
                        <b-popover
                            v-for="plaza in plazas"
                            :key="plaza.id"
                            :target="'popover-' + plaza.id" 
                            triggers="hover focus"
                        >
                            <template slot="title">{{ plaza.name }}</template>
    
                            <div v-if="plaza.disponible && plaza.precios.length > 0">{{ $t('general.desde') + ': ' + getPrecioPlaza(plaza) | formatear_precio }} </div>
                            <div v-else-if="! plaza.disponible && plaza.precios.length > 0">{{ $t('partido.ocupado') }}</div>
                            <div v-else>{{ $t('mapa.no_disponible') }}</div>
                        </b-popover>
                    </template>
                </div>
                <LeafletComponent
                    v-else
                    :plazasSeleccionadas="plazasSeleccionadas"
                    :continuarConCompra="continuarConCompra"
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import { Popover } from 'bootstrap';

export default {
    props: ['region_id', 'plazas', 'continuarConCompra', 'tipo_svg', 'plazasSeleccionadas'],
    data() {
        return {
            svg_loaded : '',
            loading: true,
            can_click: true,
            svgpanzoom: null,
            svg: null,
            svgRendered: null,
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            ocupadaColor: 'red',
            seleccionadaColor: '#8CA9D9',
            isPanning: null
        }            
    },
    created() {
        this.getSvg();
    },
    computed: {
        load_panzoom() {
            let load_panzoom = true

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if(/windows phone/i.test(userAgent)) {
                load_panzoom = false;
            }
            
            if(/android/i.test(userAgent)) {
                load_panzoom = false;
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                load_panzoom = false;
            }

            return load_panzoom;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        taquilla() {
            var path = this.$router.currentRoute.fullPath;

            return path.includes('admin');
        }
    },
    methods: {
        registerSvgPanZoom(svgpanzoom) {
            this.svgpanzoom = svgpanzoom;
        },
        zoomIn : function() {
            this.svgpanzoom.zoomIn();
        },
        zoomOut : function() {
            this.svgpanzoom.zoomOut();
        },
        getPrecioPlaza({ precios }) {
            if (precios.length > 0) {
                let precioMasBajo = precios.reduce((menorPrecio, precio) => {
                    return Math.min(menorPrecio, precio.precio);
                }, Number.POSITIVE_INFINITY)                
                
                return Math.ceil(precioMasBajo * 100) / 100;
            }

            return 0;
        },
        getSvg() {
            this.loading = true;

            let params = {
                filters: {},
                event_id: this.$route.params.event_id ?? this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                region_id: this.region_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.zonas.recintos-anexos.svg'), params)
                .then(({ data: { svg } }) => {
                    if (this.tipo_svg === 1) {
                        this.loadSVG(svg);
                    } else if (this.tipo_svg === 2) {
                        this.renderLeafletSvg(svg);
                    }
                    this.loading = false;
                }).catch(() => {
                    console.warn('Error al recuperar el SVG del recinto anexo');
                })
        },
        loadSVG(svg) {
            this.svg_loaded = svg;

            let vue_instance = this;

            setTimeout(() => {
                let plazas = document.getElementsByClassName("recinto-zona");

                for(let i in plazas) {
                    if(plazas[i].dataset !== undefined) {
                        let plaza_id = plazas[i].dataset.region;

                        for(let j in this.plazas) {
                            if(this.plazas[j].id == plaza_id && this.plazas[j].precios.length == 0) {
                                plazas[i].classList.add("no-disponible");
                            }

                            if (this.plazas[j].id == plaza_id && !this.plazas[j].disponible) {
                                plazas[i].classList.add("plaza_ocupada");                                
                            }

                            if (this.plazas[j].id == plaza_id && this.plazas[j].disponible && this.plazas[j].precios.length > 0) {
                                plazas[i].classList.add("plaza_disponible");                                
                            }
                        }

                        plazas[i].addEventListener('click', function() {
                            vue_instance.clickRegion(this.dataset.region);
                        }, false);
                    }                                                                                            
                }
            }, 500);                
        },
        clickRegion: function(plaza_id) {
            if (!this.continuarConCompra) {
                let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
    
                if (plaza && plaza.precios.length > 0 && (plaza.libre || plaza.disponible)) {
                    this.$emit('clickZona', plaza);
                }                
            }
        },
        renderLeafletSvg(svg) {
            const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;
            
            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            
            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                
                if (plaza) {
                    const title = this.getButacaName(plaza);
                    
                    if ((plaza.libre || plaza.disponible) && plaza.precios.length > 0) {
                        const content = `Desde: ${this.$n(this.getPrecioPlaza(plaza), "currency")}`
                        this.drawPopover(circle, content, title);
                
                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s';
                        circle.setAttribute('fill', this.originalColor);

                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning && !this.continuarConCompra) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickRegion(plaza.id);
                                }
                            }, 150);
                        });
                    } else if ((!plaza.disponible || plaza.ocupada.comprada_abonos || plaza.ocupada.en_sesion_abonos || plaza.ocupada.bloqueada_abonos || plaza.ocupada.venta || plaza.ocupada.sesion) && plaza.precios.length > 0) {
                        this.drawPopover(circle, 'Ocupada', title);
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.ocupadaColor);
                    } else {
                        this.drawPopover(circle, 'No disponible', title);
                        circle.setAttribute('no-disponible', 'true');
                        circle.setAttribute('fill', this.noDisponibleColor);
                    }
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },
        drawPopover(circle, content, title = null) {
            if (this.load_panzoom) {
                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover'
                }
    
                new Popover(circle, popoverOptions);                
            }
        },
        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(plaza) {
            const nButaca = plaza.butaca;
            const nFila = plaza.fila;
            const sector = plaza.sector_name;

            if (!nButaca && !nFila) {
                return `Plaza: ${plaza.numero}`;
            }

            if (sector) {
                return `Sector: ${sector} - Fila: ${nFila} - Butaca: ${nButaca}`;
            }

            return `Fila: ${nFila} - Butaca: ${nButaca}`;
        }
    },
    components : { SvgPanZoom, LeafletComponent },
}
</script>